import { dataSelector } from '@nextiva/global-store';
import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';

import { AttachmentType, postCampaignAttachment } from 'services';

export const useUpdateFileAttachments = (
  attachmentType: AttachmentType,
  controller: AbortController,
) => {
  const globalStoreData = useSelector(dataSelector);
  const corpAcctNbr = globalStoreData.user?.profileDTO?.corpAcctNbr;

  const mutation = useMutation((files: File[]) =>
    postCampaignAttachment(corpAcctNbr, attachmentType, files, controller),
  );

  return mutation;
};
